import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=c1221b12&"
import script from "./Boolean.vue?vue&type=script&lang=js&"
export * from "./Boolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports